import { Box, colors, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import RowActionsMenu from "@components/RowActionsMenu";

import { PersonalizedEmailForContactType } from "@interfaces/campaign.type";

interface ICampaignContactProperties {
  email: PersonalizedEmailForContactType;
  emailId: number;
  isBanded: boolean;
  isNonInteractive: boolean;
  isSelected: boolean;
  removeEmail: (emailId: number) => Promise<void> | void;
  setSelectedEmail: () => void;
  showActions: boolean;
}

export default function CampaignContact({
  email,
  isBanded,
  isNonInteractive,
  isSelected,
  removeEmail,
  setSelectedEmail,
  showActions,
}: ICampaignContactProperties) {
  const theme = useTheme();

  const rowMenuItems = [{ func: () => removeEmail(Number(email.id)), label: "Remove email" }];

  const getBackgroundColor = (): string => {
    if (isSelected) return theme.palette.action.hover;
    if (isBanded) return colors.grey[100];
    return theme.palette.common.white;
  };

  return (
    <Box
      onClick={setSelectedEmail}
      sx={{
        "&:hover": {
          backgroundColor: isNonInteractive ? getBackgroundColor() : theme.palette.action.hover,
        },
        alignItems: "center",
        backgroundColor: getBackgroundColor(),
        borderBottom: `1px solid ${theme.palette.borderColor.dark}`,
        cursor: isNonInteractive ? "default" : "pointer",
        display: "flex",
        flexDirection: "row",
        gap: 2,
        px: 1,
        py: 1.5,
        transition: "background-color 0.3s ease",
      }}
    >
      <Box onClick={(event) => event.stopPropagation()}>
        {showActions && <RowActionsMenu rowMenuItems={rowMenuItems} />}
      </Box>
      <Box
        sx={{
          display: { md: "inline-block", xs: "none" },
          height: 50,
          width: 50,
        }}
      >
        <img
          alt="company logo"
          src={email.imgSrc ?? ""}
          style={{
            height: "100%",
            width: "100%",
          }}
        />
      </Box>
      <Box
        sx={{
          ml: 0.5,
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            flexGrow: 1,
            gap: 1,
          }}
        >
          {/* TODO: Add back in when its fixed
          {email.personalized ? (
            <PersonRoundedIcon fontSize="small" style={{ color: "green" }} />
          ) : (
            <PersonRoundedIcon fontSize="small" style={{ color: "grey" }} />
          )}
          */}
          <Typography variant="body1">
            <strong>{email.name}</strong>
          </Typography>
        </Box>
        <Tooltip title={email.title}>
          <Typography
            sx={{
              mt: 0.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: { lg: "20rem", md: "15rem", xs: "12rem" },
            }}
            variant="body2"
          >
            {email.title}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );
}
